/* eslint-disable react/no-danger */
import React from 'react';
import { getUser } from './userHelper';
import User from '../components/User';

const userMentionRegex = /(@\[@[a-zA-Z0-9_ -]*\]\([a-zA-Z0-9_| -]*\))/gm;
const auth0UserIdRegex = /\(([a-zA-Z0-9_| -]*)\)/;
const lineBreakRegex = /\n/g;
const urlRegex = /((http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\\+.~#?&//=]*))/g;

export const getCommentStringFromMentionString = (rawComment) => {
  if (!rawComment) {
    return rawComment;
  }

  const rawCommentParts = rawComment.split(userMentionRegex);
  return (
    <div>
      {
        rawCommentParts.map((part) => {
          if (part.match(userMentionRegex)) {
            const auth0UserId = part.match(auth0UserIdRegex)[1];
            const user = getUser({ auth0UserId });
            return <User user={user} chip disableGutters />;
          }
          return <span dangerouslySetInnerHTML={{ __html: part.replace(lineBreakRegex, '<br />').replace(urlRegex, '<a href="$1">$1</a>') }} key={`comment-part-${Math.random()}`} />;
        })
      }
    </div>
  );
};
